import { render, staticRenderFns } from "./CompleteDelTips.vue?vue&type=template&id=52cdb2fd"
import script from "./CompleteDelTips.vue?vue&type=script&lang=js"
export * from "./CompleteDelTips.vue?vue&type=script&lang=js"
import style0 from "./CompleteDelTips.vue?vue&type=style&index=0&id=52cdb2fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports